export const MODULE_NAME = 'myNetworkingModule';
